import React, { useState } from "react";

export const REJECT_BOTH_LABEL = "I don’t like either movie";
export const APPROXIMATELY_EQUAL_LABEL = "I would be equally happy to watch either movie";

export function pairwiseMovieMetadata(movie) {
  return [
    movie.year,
    movie.genre ? movie.genre.split(",").slice(0, 3).map((genre) => genre.trim()).join(", ") : null,
    movie.runtime ? `${movie.runtime} min` : null,
  ].filter(Boolean).join(" • ");
}

export function PairwisePoster({ movie, width = 200, height = 300 }) {
  const [failed, setFailed] = useState(false);
  const [retries, setRetries] = useState(0);
  const posterPath = movie.posterPath ?? movie.poster;

  return posterPath && !failed ? (
    <img
      src={posterPath}
      alt={movie.title}
      style={{ width, height, objectFit: "contain" }}
      onError={(event) => {
        if (retries < 2) {
          const nextRetry = retries + 1;
          setRetries(nextRetry);
          const image = event.currentTarget;
          setTimeout(() => {
            if (image.isConnected) image.src = `${posterPath}${posterPath.includes("?") ? "&" : "?"}retry=${nextRetry}`;
          }, 1000 * nextRetry);
        } else {
          setFailed(true);
        }
      }}
      onLoad={() => setRetries(0)}
    />
  ) : (
    <div className="pairwise-poster-fallback" style={{ width, height }}>{movie.title}</div>
  );
}

export default function PairwiseMoviePresentation({ movie }) {
  const metadata = pairwiseMovieMetadata(movie);
  return <>
    <PairwisePoster key={movie.id ?? movie.imdb_tconst} movie={movie} />
    <p style={{ fontWeight: "bold", textAlign: "center", marginTop: "12px", fontSize: "var(--font-size-base)" }}>
      {movie.title}
    </p>
    <p style={{ textAlign: "left", marginTop: "10px", fontSize: "var(--font-size-base)", lineHeight: "1.5", color: "var(--color-text-primary)", padding: "0 10px" }}>
      {movie.plot ?? movie.overview ?? "No description available."}
      {metadata && <span style={{ display: "block", marginTop: "8px", fontSize: "var(--font-size-xs)", color: "var(--color-text-secondary)", fontStyle: "italic" }}>
        {metadata}
      </span>}
    </p>
  </>;
}
